import { z } from 'zod';
import { CUSTOMER_SEGMENTS } from '../types/enums.js';
import { addressSchema, emailSchema, optionalPhoneSchema, paginationQuerySchema, sortOrderSchema, uuidSchema, } from './common.js';
export const createCustomerSchema = z.object({
    name: z.string().trim().min(2, 'Customer name is required').max(120),
    email: emailSchema,
    phone: optionalPhoneSchema,
    defaultAddress: addressSchema.nullable().optional(),
    tagIds: z.array(uuidSchema).max(30).default([]),
    acceptsMarketing: z.boolean().default(false),
});
export const updateCustomerSchema = createCustomerSchema.partial();
export const customerListQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(200).optional(),
    segment: z.enum(CUSTOMER_SEGMENTS).optional(),
    tagId: uuidSchema.optional(),
    sortBy: z.enum(['createdAt', 'name', 'totalSpent', 'orderCount', 'lastOrderAt']).default('createdAt'),
    sortOrder: sortOrderSchema,
});
export const createCustomerNoteSchema = z.object({
    body: z.string().trim().min(1, 'Note cannot be empty').max(5000),
});
export const createCustomerTagSchema = z.object({
    name: z.string().trim().min(1, 'Tag name is required').max(60),
    colour: z
        .string()
        .regex(/^#[0-9a-fA-F]{6}$/, 'Choose a valid colour')
        .default('#64748b'),
});
//# sourceMappingURL=customer.js.map